import { useEffect, useState, useRef } from "react";
import {
  UserCreateService,
  UserListService,
  UserUpdateService,
  UserDeleteService,
  UserByIDService,
} from "../services/UserService";
import UserList from "../modules/UserList";
import { UserCreate } from "../modules/UserCreate";
import { UserEdit } from "../modules/UserEdit";
import { UserDelete } from "../modules/UserDelete";
import { RoleListService } from "layouts/role/services/RoleService";
// import FilterController from "components/filter/controller/FilterController";
import Spinner from "components/MDSpinner";
import MDAlert from "components/Alert";
import FilterController from "components/filter/controller/FilterController";
import { PermissionsByRoleId } from "layouts/edit_role/services/EditRoleService";
import { name } from "dayjs/locale/es";
import { updateRolePermissions } from "layouts/edit_role/services/EditRoleService";

export default function UserController() {
  const filterConfig = [
    { visibleName: "Nombres", dbField: "first_name", type: "text" },
    { visibleName: "Apellidos", dbField: "last_name", type: "text" },
    { visibleName: "Correo electrónico", dbField: "email", type: "text" },
    { visibleName: "Rol", dbField: "role", type: "text" },
    { visibleName: "Estado", dbField: "status", type: "text" },
    // { visibleName: "Fecha de creación", dbField: "created_at", type: "date" },
  ];

  const dataTable = "users"; //Tabla indicada
  // Common Controllers
  const [isDisabled, setIsDisabled] = useState(false);
  const [defaultData, setDefaultData] = useState({});
  const [isFormModified, setIsFormModified] = useState(false);
  const [recoveredData, setRecoveredData] = useState({});
  const [editedData, setEditedData] = useState({});
  const [newData, setNewData] = useState({});
  const [buildData, setBuildData] = useState({});
  const [loading, setLoading] = useState(false);
  const header = [{}];
  const filterControllerRef = useRef();
  const [roleName, setRoleName] = useState("");

  // Field Check
  const [handleRoleList, setRoleList] = useState([]);

  // const requestRoleList = async () => {
  //   const result = await RoleListService();
  //   if (result && result.payload) {
  //     const { payload } = result;
  //     const rolePermitsArray = Object.entries(payload);

  //     setRoleList(rolePermitsArray);
  //   }
  // };

  // (() => {
  //   requestRoleList();
  // }, []);

  const getFieldValueNew = (fieldName) => {
    return newData[fieldName];
  };

  const getFieldValue = (fieldName) => {
    return editedData[fieldName];
  };

  const handleFieldChangeNew = (fieldName, value) => {
    if (fieldName === "data_types") {
      setNewData({
        ...newData,
        [fieldName]: [{ data_type_id: 1, value: value, principal: false }],
      });
    } else {
      setNewData({
        ...newData,

        [fieldName]: value,
      });
    }
    handleChangeValid(fieldName, value);
  };

  const handleFieldChange = (fieldName, value, role_name, value_role_name) => {
    if (fieldName === "data_types") {
      setEditedData({
        ...editedData,
        [fieldName]: [{ data_type_id: 1, value: value, principal: false }],
      });
    } else {
      setEditedData({
        ...editedData,

        [fieldName]: value,
      });
    }
    if (role_name === "role_name") {
      setEditedData({
        ...editedData,
        [role_name]: value_role_name,
      });
    }
    if (fieldName !== "role_name") {
      handleChangeValid(fieldName, value);
    }
  };

  // ByID Controllers

  const requestUserByID = async (idUser) => {
    try {
      const user = await UserByIDService(idUser);
      const { payload } = user;
      return { payload };
    } catch (error) {}
  };

  const requestListRoles = async () => {
    try {
      // Llama al servicio para obtener la lista de roles
      const result = await RoleListService(1, 1000);

      if (result.success) {
        return result.payload.data;
      } else {
        handleAlert("fail", result.message);
      }
    } catch (error) {
      console.error("Error fetching roles:", error);
      // Maneja el error aquí si es necesario
    }
  };

  // const requestListRoles = async () => {
  // try {
  //   const listRoles = await RoleListService(1);
  // const { data } = listRoles;
  //  return listRoles;
  // } catch (error) {}
  // };

  // List Controllers

  const [handleUserList, setUserList] = useState();
  const [totalPages, setTotalPages] = useState(0);
  const [totalData, setTotalData] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesStart, setEntriesStart] = useState(0);
  const [entriesEnd, setEntriesEnd] = useState(0);
  const [paginaSize, setPaginaSize] = useState(10);
  const [typeAlert, setTypeAlert] = useState("");
  const [message, setMessage] = useState("");
  const [isAlert, setIsAlert] = useState(false);

  // Maneja las alertas de exito fallo
  const handleAlert = (typeAlert, message) => {
    setTypeAlert(typeAlert);
    setMessage(message);
    setIsAlert(true);
  };

  const requestUserList = async (pageIndex) => {
    const result = await UserListService(pageIndex, 10);

    if (result.success) {
      // const { payload } = result;
      const { payload } = result;
      await setUserList(result.payload.data);
      await setTotalPages(payload.last_page);
      await setTotalData(payload.total);
      await setEntriesStart(payload.from);
      await setEntriesEnd(payload.to);
    } else {
      handleAlert("fail", result.message);
    }
  };

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const pageIndexAndPageSize = async (pageSize) => {
    await setPaginaSize(pageSize);
    requestUserList(currentPage === 1 ? currentPage : (currentPage - 1) * pageSize + 1);
  };

  useEffect(() => {
    setLoading(true);
    requestUserList(currentPage);
    setLoading(false);
  }, [currentPage]);

  // List Role Controllers
  /*
  const [handleRoleList, setRoleList] = useState();

  const requestRoleList = async (pageIndex) => {
    const result = await RoleListService(pageIndex);
    if (result && result.payload) {
      const { payload } = result;
      const roleArray = Object.entries(payload.data);
      setRoleList(payload.data);
    }
  };

  (() => {
    requestRoleList();
  }, []);
 */

  // Create Controllers

  const [openCreate, setOpenCreate] = useState(false);

  const handleUserCreate = async (event) => {
    event.preventDefault();

    // Obtén la lista de roles
    const listRoles = await requestListRoles();
    setRoleList(listRoles);
    setIsDisabled(false);
    resetFieldValid();

    // Prepara los datos del nuevo usuario e incluye el software_id
    const data = {
      first_name: "",
      last_name: "",
      status: "Inactivo",
      role_id: "",
      data_types: [{ data_type_id: 1, value: "", principal: false }],
    };

    setDefaultData(data);
    setNewData(data);
    setOpenCreate(true);
  };

  const submitUserCreate = async (e) => {
    e.preventDefault();

    const hasErrors = hasInvalidFields(isFieldValid);

    //Comprobar si hubo algun campo con errores
    if (hasErrors) {
      handleAlert("fail", "Hay al menos un error en los campos ingresados");
      return;
    }
    // Obtén el software_id del localStorage
    const softwareId = sessionStorage.getItem("software_id");

    // Verifica si el software_id existe
    if (!softwareId) {
      handleAlert("fail", "Error: El software_id no está disponible.");
      return;
    }

    // Incluye el software_id en los datos (newData)
    const softwareIdWithoutHyphens = softwareId.replace(/-/g, "");
    const role_id = newData["role_id"].replace(/-/g, "");
    const updatedData = {
      ...newData,
      software_id: softwareIdWithoutHyphens,
      role_id: role_id,
    };

    for (const field in isFieldValid) {
      if (!isFieldValid[field]) {
        return;
      }
    }

    // Llamada al servicio de creación
    const response = await UserCreateService(updatedData);

    // Manejo de la respuesta
    // Manejo de la respuesta
    if (response.success) {
      const successMessage = response.payload?.message || "El usuario se ha creado correctamente.";
      handleAlert("success", successMessage);
      requestUserList(currentPage);
      callHandleClickSubmit();
      closeUserCreate();
    } else {
      // Mandar mensaje de error para renderizar en la alerta
      handleAlert("fail", response.message);
    }
  };

  const closeUserCreate = () => setOpenCreate(false);

  // Edit Controllers

  const [openEdit, setOpenEdit] = useState(false);
  const [listRoles, setLisRoles] = useState([]);

  const handleUserEdit = async (event) => {
    event.preventDefault();

    resetFieldValid();
    // Obtener el ID del usuario desde el dataset del evento
    const userId = event.currentTarget.dataset.id;

    const { dataset } = event.currentTarget;

    const updatedData = {
      id: dataset.id,
      first_name: dataset.firstname,
      last_name: dataset.lastname,
      status: dataset.status,
      data_types: [{ data_type_id: 1, value: dataset.email, principal: false }],
      role_id: dataset.role,
      role_name: dataset.rolename,
    };

    // Obtén la lista de roles
    const listRoles = await requestListRoles();
    setRoleList(listRoles);

    setRecoveredData(updatedData);
    setEditedData(updatedData);

    // Deshabilitar el formulario si el ID es "view"
    setIsDisabled(userId === "view");
    // Abrir el modal de edición
    setOpenEdit(true);
  };

  const submitUserEdit = async (e) => {
    e.preventDefault();

    const hasErrors = hasInvalidFields(isFieldValid);

    //Comprobar si hubo algun campo con errores
    if (hasErrors) {
      handleAlert("fail", "Hay al menos un error en los campos ingresados");
      return;
    }
    //Validar si todos los campos son válidos antes de proceder
    for (const field in isFieldValid) {
      if (!isFieldValid[field]) {
        return;
      }
    }

    try {
      let role = JSON.parse(sessionStorage.getItem("role"));
      let user_id = sessionStorage.getItem("user_id");
      const { id } = role;

      if (editedData.id == user_id) {
        if (editedData.role_id != id) {
          handleAlert(
            "fail",
            "No puedes cambiar tu propio rol. Por favor, contacta a otro administrador."
          );
          return;
        }
      }
      // Hacer la solicitud para actualizar el usuario
      const response = await UserUpdateService(editedData.id, editedData);

      // Manejo de la respuesta
      if (response.success) {
        handleAlert("success", "El usuario se ha editado correctamente.");
        await requestUserList(currentPage); // Actualizar la lista de usuarios
        if (editedData.role_id != id) {
          if (editedData.id != user_id) {
            const roleData = {
              id: editedData.role_id,
              name: roleName,
            };
            sessionStorage.setItem("role", JSON.stringify(roleData)); // Actualizar el rol en localStorage
            sessionStorage.setItem("permissions", JSON.stringify([]));
            await fetchPermissionsByRol(editedData.role_id); // Actualizar los permisos por rol
          }
        }
        callHandleClickSubmit(); // Llamar la función relacionada con el submit
        closeUserEdit(); // Cerrar el modal o formulario de edición
      } else {
        // Si falla, mostrar el mensaje de error y no realizar ninguna otra acción
        handleAlert("fail", response.message || "Error al editar el usuario.");
      }
    } catch (error) {
      // Si ocurre un error durante la solicitud, manejar el error
      console.error("Error during user edit:", error);
      handleAlert("fail", "Ocurrió un error al procesar la solicitud.");
    }
  };

  //Obtener los permisos por rol
  const fetchPermissionsByRol = async (idRoleUpdate) => {
    try {
      const roleResult = await PermissionsByRoleId(idRoleUpdate);
      if (roleResult.success) {
        // const permissions = JSON.stringify(roleResult.payload); // Convierte el array de permisos a JSON
        sessionStorage.setItem("permissions", JSON.stringify(roleResult.payload));
        
        updateRolePermissions(JSON.stringify(roleResult.payload));
      } else {
        console.error(roleResult.message || "Error al obtener los permisos por rol");
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   const requiredFields = ["first_name", "last_name", "status", "data_types", "role_id"];
  //   const someFieldIsEmpty = requiredFields.some((fieldName) => !newData[fieldName]);
  //   setIsFormModified(someFieldIsEmpty);
  // }, [newData]);

  useEffect(() => {
    // Comprueba si algún campo ha cambiado desde los valores iniciales
    //const hasFormChanged = Object.keys(newData).some((fieldName) => newData[fieldName] !== "");
    //const requiredFields = ["name", "source", "perfil", "created"];
    const requiredFields = Object.keys(newData).filter(
      (clave) => clave !== "db_password" && clave !== "created" && clave !== "expires_in"
    );
    const someFieldIsEmpty = requiredFields.some((fieldName) => !newData[fieldName]);
    setIsFormModified(someFieldIsEmpty);
  }, [newData]);

  const closeUserEdit = () => setOpenEdit(false);

  // Delete Controllers

  const [openDelete, setOpenDelete] = useState(false);
  const [infoDelete, setInfoDelete] = useState({});

  const requestUserDelete = async (id) => {
    try {
      const result = await UserDeleteService(id);
      if (result.success) {
        handleAlert("fail", result.message);
      } else {
        handleAlert("success", result.message);
      }
    } catch (error) {
      handleAlert("fail", error.message || "Error al eliminar el rol");
      console.error(error);
    }
  };

  const handleUserDelete = (event, userDelete) => {
    event.preventDefault();

    const data = {
      id: userDelete.id,
      name: userDelete.first_name,
      lastname: userDelete.last_name,
      email: userDelete.datatypeuser.value,
      status: userDelete.status,
      role_id: userDelete.roles.id,
    };
    setInfoDelete(data);
    setOpenDelete(true);
  };

  const submitUserDelete = async (e) => {
    e.preventDefault();
    await requestUserDelete(infoDelete.id, infoDelete.id);
    await requestUserList(currentPage);
    callHandleClickSubmit();
    closeUserDelete();
  };

  const closeUserDelete = () => setOpenDelete(false);

  // Empty dependency array means this effect runs once on mount

  // Test Keys

  useEffect(() => {
    const hasFormChanged = Object.keys(editedData).some(
      (fieldName) => editedData[fieldName] !== recoveredData[fieldName]
    );

    const isAnyFieldEmpty = Object.values(editedData).some((value) => value === "");

    setIsFormModified(!isAnyFieldEmpty && hasFormChanged);
  }, [editedData]);

  // (() => {
  //   const requiredFields = ["name", "description"];
  //   const someFieldIsEmpty = requiredFields.some((fieldName) => !newData[fieldName]);
  //   setIsFormModified(someFieldIsEmpty);
  // }, [newData]);

  // Stringify

  function convertValuesToString(objeto) {
    const convertedObject = {};

    for (const clave in objeto) {
      if (objeto.hasOwnProperty(clave)) {
        convertedObject[clave] = String(objeto[clave]);
      }
    }

    return convertedObject;
  }

  // Estado de las validaciones
  const [isFieldValid, setIsFieldValid] = useState({
    first_name: true,
    last_name: true,
    data_types: true,
    role_id: true,
    status: true,
  });

  // Función para verificar si algún campo no es válido
  const hasInvalidFields = (fields) => {
    return Object.values(fields).some((value) => value === false);
  };

  // Setea los valores de las validaciones
  const resetFieldValid = () => {
    setIsFieldValid({
      first_name: true,
      last_name: true,
      data_types: true,
      role_id: true,
      status: true,
    });
  };

  // Expresiones regulares para diferentes tipos de campos
  const validationPatterns = {
    first_name: /^[a-zA-ZÀ-ÿ\s\u00f1\u00d1]+$/, // Solo permite letras y espacios
    last_name: /^[a-zA-ZÀ-ÿ\s\u00f1\u00d1]+$/, // Solo permite letras y espacios
    data_types: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/, // Verifica el formato de correo electrónico
    role_id: /^[\s\S]*\S[\s\S]*$/, // Al menos un carácter que no sea un espacio
    status: /^[\s\S]*\S[\s\S]*$/, // Al menos un carácter que no sea un espacio
  };

  // Compara el valor del input con la expresion regular requerida
  const validateField = (value, pattern) => {
    return pattern.test(value);
  };

  // Comprueba la validez del campo y luego establece la validez en el estado
  const handleChangeValid = (fieldName, value) => {
    const isFieldValid = validateField(value.trim(), validationPatterns[fieldName]);

    // if (!value) {
    //   setIsFieldValid((prevValidity) => ({
    //     ...prevValidity,
    //     [fieldName]: true,
    //   }));
    //   return;
    // }

    setIsFieldValid((prevValidity) => ({
      ...prevValidity,
      [fieldName]: isFieldValid,
    }));
  };

  // Función para llamar a handleClickSubmit desde el componente padre
  const callHandleClickSubmit = () => {
    if (filterControllerRef.current) {
      filterControllerRef.current.handleClickSubmit();
    }
  };

  return (
    <>
      <Spinner loading={loading}></Spinner>
      <MDAlert
        isAlert={isAlert}
        setIsAlert={setIsAlert}
        typeAlert={typeAlert}
        message={message}
      ></MDAlert>
      <FilterController
        filterConfig={filterConfig}
        dataTable={dataTable}
        setTotalData={setTotalData}
        setEntriesEnd={setEntriesEnd}
        setEntriesStart={setEntriesStart}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        setTotalPages={setTotalPages}
        setListData={setUserList}
        handleAlert={handleAlert}
      ></FilterController>
      <UserList
        handleUserList={handleUserList}
        handleUserCreate={handleUserCreate}
        handleUserEdit={handleUserEdit}
        handleUserDelete={handleUserDelete}
        pageIndexAndPageSize={pageIndexAndPageSize}
        entriesStart={entriesStart}
        entriesEnd={entriesEnd}
        totalData={totalData}
        totalPages={totalPages}
        currentPage={currentPage}
        handlePageChange={handlePageChange}
      />

      <UserCreate
        open={openCreate}
        handleUserCreate={handleUserCreate}
        handleClose={closeUserCreate}
        isFormModified={isFormModified}
        isDisabled={isDisabled}
        getFieldValue={getFieldValueNew}
        handleFieldChange={handleFieldChangeNew}
        handleSubmit={submitUserCreate}
        isFieldValid={isFieldValid}
        handleRoleList={handleRoleList}
      />

      <UserEdit
        open={openEdit}
        handleClose={closeUserEdit}
        isFormModified={isFormModified}
        isDisabled={isDisabled}
        getFieldValue={getFieldValue}
        handleFieldChange={handleFieldChange}
        handleSubmit={submitUserEdit}
        listRoles={listRoles}
        isFieldValid={isFieldValid}
        handleRoleList={handleRoleList}
        setRoleName={setRoleName}
      />

      <UserDelete
        openDelete={openDelete}
        closeDelete={closeUserDelete}
        infoDelete={infoDelete}
        submitDelete={submitUserDelete}
      />
    </>
  );
}
